import React, { useEffect, useState, memo } from "react";
import { Line } from "react-chartjs-2";
import { isEqual } from "lodash";

const LineGraph = ({ data, unit }) => {
  return (
    <Line
      options={{
        scales: {
          y: {
            ticks: {
              callback: function (value, index, values) {
                return value + `${unit}`;
              },
            },
          },
        },

        elements: {
          line: {
            tension: 0.2,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      }}
      data={data}
    />
  );
};

export default memo(LineGraph, isEqual);
